import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CTASection from './components/CTASection';
import HomePortfolioSection from './components/HomePortfolioSection';
import ServicesShowcaseSection from '../portfolio/components/ServicesShowcaseSection';
import ToolsSection from '../../components/feature/ToolsSection';
import ValuePropositionSection from './components/ValuePropositionSection';
import HeroSectionVideo from './components/HeroSectionVideo';
import CertifiedExpertise from '../servicesgroup/components/CertifiedExpertise';
import HomeBlogSection from './components/HomeBlogSection';
import SEO from '../../components/base/SEO';

export default function Home() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <SEO 
        title="Drafting By DMI | Professional AV Drafting, Takeoff & Programming"
        description="Expert Drafting, Takeoff, and Programming Services. Precision CAD & BIM solutions including architectural floor plans and 3D renderings for the AV industry."
        url={window.location.href}
      />
      <Header />
      <main>
        <HeroSectionVideo />
        <ServicesShowcaseSection />
        <HomePortfolioSection />
        <ToolsSection />
        <ValuePropositionSection />
        <CertifiedExpertise />
        <HomeBlogSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
